/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */

import React from 'react';
import { connect } from 'react-redux';

import {
    Translate,
} from "src/shared_modules/i18n";

import {
    openContentOrPageClickHandler
} from "src/shared_modules/veu-visitors-core/components/content-view/utils";

import {
    showStaticContent
} from "src/shared_modules/veu-visitors-core/actions/content";

import {
    showPageGlobal
} from "src/shared_modules/veu-visitors-core/actions/pages";

import { useTheme } from '@material-ui/core/styles';

import './footer.css';

import {
    NAME,
    MODULE,
    VERSION,
    COPYRIGHT
} from "src/constants";

import {
    VEU_CORE_VERSION,
    VEU_NAME,
} from "src/shared_modules/veu-visitors-core/constants";

import {
    SYSTEM_CONTENT
} from "src/constants";




/*
 * ---------------------------------------------------------------------
 * Component AppFooter
 * ---------------------------------------------------------------------
 */
function AppFooter(props) {
    const theme = useTheme();

    //set the variable for our css!
    const themedStyle = {
        "--themeSecondaryMain": theme.palette.secondary.main
    }


    const renderSEVENM = () => {
        if( SYSTEM_CONTENT.SEVENM.show === true ) {
            return (
                <React.Fragment>
                    <button style={themedStyle} onClick={() => { openContentOrPageClickHandler(SYSTEM_CONTENT.SEVENM) }} >SEVEN M GmbH</button>
                </React.Fragment>
            )
        }

    }

    const renderLegalNotice = () => {
        if (SYSTEM_CONTENT.LEGAL_NOTICE.show === true) {
            return (
                <React.Fragment>
                    &nbsp;&nbsp; | &nbsp;&nbsp; <button style={themedStyle} onClick={() => { openContentOrPageClickHandler(SYSTEM_CONTENT.LEGAL_NOTICE) }} >
                        <Translate>footer.legal-notice</Translate>
                    </button>
                </React.Fragment>
            )
        }
    }

    const renderPrivacy = () => {
        if (SYSTEM_CONTENT.PRIVACY_POLICY.show === true) {
            return (
                <React.Fragment>
                    &nbsp;&nbsp; | &nbsp;&nbsp; <button style={themedStyle} onClick={() => { openContentOrPageClickHandler(SYSTEM_CONTENT.PRIVACY_POLICY) }} >
                        <Translate>footer.privacy-policy</Translate>
                    </button>
                </React.Fragment>
            )
        }
    }

    const renderConditionOfUse = () => {
        if (SYSTEM_CONTENT.CONDITION_OF_USE.show === true) {
            return (
                <React.Fragment>
                    &nbsp;&nbsp; | &nbsp;&nbsp; <button style={themedStyle} onClick={() => { openContentOrPageClickHandler(SYSTEM_CONTENT.CONDITION_OF_USE) }} >
                        <Translate>footer.condition-of-use</Translate>
                    </button>
                </React.Fragment>
            )
        }
    }

    const renderCookiePolicy = () => {
        if (SYSTEM_CONTENT.COOKIE_POLICY.show === true) {
            return (
                <React.Fragment>
                    &nbsp;&nbsp; | &nbsp;&nbsp;  <button style={themedStyle} onClick={() => { openContentOrPageClickHandler(SYSTEM_CONTENT.COOKIE_POLICY) }} >
                        <Translate>footer.cookie-policy</Translate>
                    </button>
                </React.Fragment>
            )
        }
    }


    return (<footer className="app-footer">
        <div>
            {NAME} {MODULE} v{VERSION} - {VEU_NAME} v{VEU_CORE_VERSION} - {COPYRIGHT}&nbsp;&nbsp;
            {renderSEVENM()}
            {renderLegalNotice()}
            {renderPrivacy()}
            {renderConditionOfUse()}
            {renderCookiePolicy()}
        </div>
    </footer>);

}


const mapDispatchToProps = {
    showStaticContent,
    showPageGlobal,
};
export default connect(
    null,
    mapDispatchToProps
)(AppFooter);
